// Who may open an admin page (docs/TODO.md Part 0, A1).
//
// Asks the server for the person's role instead of comparing against one
// hard-coded account, so a helper listed in VIEWER_UIDS on the server can
// open the panel read-only. `allow` names the roles this page is for; the
// page is handed the role as a `role` prop. Everyone else goes to the
// dashboard, as before. The server refuses every route on its own as well.
//
// When the server gives no answer at all (rolled back, restarting, down),
// the founder's account still opens the page, with a note saying why parts
// of it may be empty (utils/admin.js useAdminRole).
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../AuthContext';
import { useAdminRole } from '../../utils/admin';

export default function AdminRoute({ allow = ['admin'], children }) {
  const { currentUser } = useAuth();
  const { loading, role, unsure } = useAdminRole(currentUser);
  if (loading) {
    return (
      <div className="py-5 text-center text-muted">
        <Spinner animation="border" size="sm" className="me-2" />
        Checking your access…
      </div>
    );
  }
  if (!role || !allow.includes(role)) return <Navigate to="/dashboard" replace />;
  const page = React.cloneElement(children, { role });
  if (!unsure) return page;
  return (
    <>
      <Alert variant="warning" className="m-3 mb-0 small" role="status">
        We couldn't reach the server to check your access, so parts of this page may not load.
        Try again in a minute.
      </Alert>
      {page}
    </>
  );
}
